import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { MantenedorConvenioColaboracionService } from 'src/app/services/mantenedor-convenio-colaboracion/mantenedor-convenio-colaboracion.service';
import { ConfirmationDialog } from '../confirmation-dialog/confirmation-dialog.component';
import Swal from 'sweetalert2';
import { DialogCrearConvenioColaboracion } from './crear-convenio-colaboracion.component';
import { DialogEditaConvenioColaboracion } from './edita-convenio-colaboracion.component';



export interface DialogData 
{
    sexo: any
    estadoCivil: any
    regiones: any
    regionesDirDat: any
    comunas: any
    comunasDirDat: any
    roles: any
    recarga: boolean
    tipoAfiliado: any
    prevision: any
    sistemaSalud: any
}

@Component({
    selector: 'app-mantenedor-convenio-colaboracion',
    templateUrl: '../../pages/mantenedor-convenio-colaboracion/mantenedor-convenio-colaboracion.component.html',
    styleUrls: ['../../pages/mantenedor-convenio-colaboracion/mantenedor-convenio-colaboracion.component.css']
})
export class MantenedorConvenioColaboracionComponent implements OnInit {
    rol: string = localStorage.getItem("rol")
    nombreUsuario: string = localStorage.getItem("nombreUsuario")
    proveedores:any
    config: any = { itemsPerPage: 10, currentPage: 1, totalItems: 0, indexInicial: 0, indexMaximo: 10 }
    allComplete: boolean = false
    usuarios: any
    usuariosFinales: any
    buscador: any = { correo: '', rut: '' }
    regiones:any
    
    constructor(private dialog: MatDialog,
         private mantenedorConvenioColaboracionService: MantenedorConvenioColaboracionService) { }

    ngOnInit(): void {
        let vm = this
       
        vm.mostrarListaConvenioColaboracionSinFiltro();
    }
    mostrarListaConvenioColaboracionSinFiltro(){
        let vm = this
        
        this.mantenedorConvenioColaboracionService.muestraListaConvenioColaboracion(this.buscador).then
        (
            (listaProveedores: any) =>
            { 
            
            vm.proveedores = listaProveedores.resultado
            vm.buscador.paginasTotal = listaProveedores.resultado.length
            vm.config.currentPage = this.buscador.currentPage
            vm.config.totalItems = listaProveedores.cantidadRegistros
            this.buscador.rut = ''
            })             
      .catch
     (
         error =>
         {
             console.log("error",error)
             this.openAlertDialog('Ha ocurrido un error para buscar la lista de proveedores.', 'btn-danger')
         }
     )
    }
    crearConvenioColaboracion() {

        let vm = this
        let data: any = {}

        const dialogRef = this.dialog.open(DialogCrearConvenioColaboracion, { data: data,  disableClose: true, width: '40%' })
        dialogRef.afterClosed().subscribe(() => {
            console.log("crearConvenioColaboracion:",data)
            this.mostrarListaConvenioColaboracionSinFiltro();
            if (data.recarga) {
              Swal.fire({
                allowOutsideClick:false,
                icon:'info',
                text:'Cargando...'
              });
              Swal.showLoading();
                vm.usuariosFinales = []
               

            }
        })
    }
    buscar(){
        
        if(this.buscador.rut == ''){ 
            this.mostrarListaConvenioColaboracionSinFiltro();
        }
        this.mantenedorConvenioColaboracionService.buscarConvenioColaboracion(this.buscador.rut).then(
            (response : any)=>{
                
                this.proveedores = response.resultado
                this.buscador.paginasTotal = response.resultado.length
                this.config.currentPage = this.buscador.currentPage
                this.config.totalItems = response.cantidadRegistros
               
            }
            ).catch ( error =>
                {
                    console.log(error)
                      Swal.close();
                    this.openAlertDialog('No se han encontrado resultados.', 'btn-danger')
                } ) 

    }
  
    editarProveedor(idProveedor: any){
      
        let vm = this
        let data: any = {}
        this.mantenedorConvenioColaboracionService.traeRegiones().then(regiones => data.regiones = regiones).catch(error => console.log(error));
      
         this.mantenedorConvenioColaboracionService.traeDatosProveedor(idProveedor).then(
           
            (proveedor : any)=>{  
                
                if (proveedor.fechaInicio) {  
                    data.fechaInicio = proveedor.fechaInicio.split('-').length > 0 ?
                    proveedor.fechaInicio.split('-')[2] + '-' + proveedor.fechaInicio.split('-')[1] + '-' + proveedor.fechaInicio.split('-')[0] : ''
                 }else{
                    proveedor.fechaInicio=[]
                 }

                 if (proveedor.fechaFin) {  
                    data.fechaFin = proveedor.fechaFin.split('-').length > 0 ?
                    proveedor.fechaFin.split('-')[2] + '-' + proveedor.fechaFin.split('-')[1] + '-' + proveedor.fechaFin.split('-')[0] : ''
                 }else{
                    proveedor.fechaFin=[]
                 }

                {                   
                    data.id= proveedor.id,
                    data.rut = proveedor.rut,
                    data.dv= proveedor.dv,        
                    data.nombre = proveedor.nombre,
                    data.razonSocial = proveedor.razonSocial,
                    data.fechaInicio = data.fechaInicio,
                    data.fechaFin = data.fechaFin,
                    data.descripcion = proveedor.descripcion,
                    data.ciudad = proveedor.ciudad,
                    data.region = proveedor.region,
                    data.idRegion= proveedor.idRegion,
                    data.regiones = data.regiones,
                    data.categorias = data.categorias,
                    data.url = proveedor.url,
                    data.rol = localStorage.getItem("rol"),
                    data.visibleConvenio = proveedor.visibleConvenio
                }      
                const dialogRef = this.dialog.open(DialogEditaConvenioColaboracion, 
                    { data: data,  disableClose: true, width: '40%' })
                dialogRef.afterClosed().subscribe(() => { this.mostrarListaConvenioColaboracionSinFiltro();});
              
                vm.usuariosFinales = []
                this.buscador.rut = ''
            }
      
            
        )
         .catch ( error =>
            {
                console.log(error)
                  Swal.close();
                vm.openAlertDialog('Ha ocurrido un error para ver los datos del proveedor.', 'btn-danger')
            } )
        
    }
    modificarEstadoProveedor(id:any, estado:any){
        let vm = this
        const dialogRef = this.dialog.open(ConfirmationDialog, {
            data: { message: '¿Esta seguro de cambiar el estado del Convenio de Colaboración?', buttonText: { ok: 'Si', cancel: 'No' } }
        })

        dialogRef.afterClosed().subscribe((confirmed: boolean) => {
            if (confirmed) {
              Swal.fire({
                allowOutsideClick:false,
                icon:'info',
                text:'Cargando...'
              });
              Swal.showLoading();
                if (estado == true) { estado = false }

                else { estado = true }
                
                vm.mantenedorConvenioColaboracionService.modificarEstado(id, estado).then
                    (
                        () => {
                            vm.openAlertDialog("Se ha modificado exitosamente el estado del convenio de colaboración.", "btn-success")
                            Swal.close();
                            dialogRef.close()
                            this.mostrarListaConvenioColaboracionSinFiltro();
                            this.buscador.rut=''
                        }
                    )
                    .catch(error => {
                        console.log(error)

                        vm.openAlertDialog("Ha ocurrido un error el convenio el usuario.", "btn-danger")
                          Swal.close();
                        dialogRef.close()
                    })                    
            }
        })
    }   
   

    updateAllComplete()
    {
        this.allComplete =  this.proveedores != null && this.proveedores
                            .slice(this.config.indexInicial, this.config.indexMaximo)
                            .every(p => p.seleccionado)
    }
    openAlertDialog(mensaje: string, clase: string) {
        this.dialog.open(AlertDialogComponent,
            {
                data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' } }
            })
    }

    pageChanged(event: any) {
        this.config.currentPage = event

        this.config.indexInicial = ((this.config.currentPage - 1) * this.config.itemsPerPage)
        this.config.indexMaximo = (this.config.currentPage * this.config.itemsPerPage)
    }

    cambiaCantidadRegistros() {
        this.config.indexInicial = 0, this.config.indexMaximo = this.config.itemsPerPage, this.config.currentPage = 1
    }
   
}
  